import React from 'react'
import TaskStepItem from '../../profile/components/TaskStepItem'
import { getOfferTaskStatus } from 'services/api.user.service'
import { useQuery } from '@tanstack/react-query'

export default function GivewayTask({
    setting
}) {

    const {
        isPending,
        // error,
        data,
    } = useQuery({
        queryKey: ['getOfferTaskStatus'],
        queryFn: () => getOfferTaskStatus(),
    })

    // if (isPending)
    //     return <div>Loading...</div>

    const status = data?.data || {
        isAllFinished: false,
        favoriteListCount: 0,
        favoriteStoresCount: 0,
        inviteFriendsCount: 0,
        scanQRCode: false,
        downloadApp: false,
        createAccount: true,
        entries: 0
    }

    return (
        <div className='w-[1280px] smsize:w-full smsize:px-5 smsize:py-0' id='contest-section'>
            <h4 className='uppercase text-[25px] font-normal text-left mb-3'>
                My contests
            </h4>
            <div className='m-auto shadow smsize:w-full bg-white rounded-2xl text-[#E4B456] border p-5 text-left flex flex-col gap-3 smsize:border-0 smsize:rounded-none smsize:shadow-none'>
                <div>
                    <h3 className='uppercase text-[20px]'>
                        {setting?.title}
                    </h3>
                    {setting?.description && (
                        <p className='text-[16px] text-gray-500' dangerouslySetInnerHTML={{ __html: setting?.description }}></p>
                    )}
                    {setting?.endAt && (
                        <span className='text-[14px] text-gray-400'>
                            Contest Ends {new Date(setting?.endAt).toLocaleDateString()}
                        </span>
                    )}
                    {/* <p className='uppercase text-[20px] font-light text-[#CD9426]'>checklist</p> */}
                </div>
                {/* <div className='w-full flex justify-between items-end'>
                    <span className='bg-[#F9EDD7] text-[16px] rounded-full px-5 py-2 w-[160px]'>
                        Your Entries: <strong>{status?.entries}</strong>
                    </span>
                </div> */}
                <div className='border-[#F5E2BB] border rounded-2xl flex gap-5 smsize:flex-col'>
                    <div className='p-3 flex flex-col gap-2'>
                        <h4 className='uppercase text-[16px] text-[#E4B456] font-light'>Your Entries: <strong>{status?.entries}</strong></h4>
                        {/* <div className='flex text-left gap-5 smsize:flex-col'>
                            <TaskStepItem text="Create an Account" isCompleted={status?.createAccount} />
                            <TaskStepItem text="Download the Fitzba mobile app" isCompleted={status?.downloadApp} />
                            <TaskStepItem text="Visit participating stores" isCompleted={status?.favoriteStoresCount > 0} />
                            <TaskStepItem text="Add items to shopping cart" isCompleted={status?.favoriteListCount > 0} />
                            <TaskStepItem text="Invite a Friend" isCompleted={status?.inviteFriendsCount > 0} />
                        </div> */}
                        <div className='flex text-left gap-5 smsize:flex-col'>
                            {setting?.entries?.map((entry, index) => {
                                if (!entry.code || !entry.title) return null
                                const statusValue = status[entry.code] || false
                                return <TaskStepItem
                                    key={index}
                                    text={typeof statusValue === 'number' && statusValue > 1 ? `${entry.title} (${statusValue})` : entry.title}
                                    isCompleted={status[entry.code]}
                                />
                            })}
                        </div>
                    </div>
                    {/* <div className='p-3 flex flex-col gap-2 border-[#F5E2BB] border-l'>
                        <h4 className='uppercase text-[16px] text-[#E4B456] font-light'>Repeatable Entries</h4>
                        <div className='flex text-left gap-5 smsize:flex-col'>
                            <TaskStepItem text="Scan a Fitzba store QR" isCompleted={status?.scanQRCode}
                                desc="Per store once a day"
                            />
                            <TaskStepItem text="Invite a Friend" isCompleted={status?.inviteFriendsCount > 0} />
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}
